export default __webpack_public_path__ + "static/media/mural-paint-backup.74da95a5.jpg";